<script setup lang="ts">
  import BulletPoint from '../../tips/BulletPoint.vue';
</script>

<template>
  <div>
    <p><BulletPoint />Relatório Mensal.pdf</p>
    <p><BulletPoint />Contrato cliente ABC.pdf</p>
    <p><BulletPoint />Certificado ISO 9001.pdf</p>
  </div>
</template>
